import { b2b, b2c, coolGrey } from './colors';
// import PretendardBold from './fonts/Pretendard-Bold.woff2';
// import PretendardMedium from './fonts/Pretendard-Medium.woff2';
// import PretendardRegular from './fonts/Pretendard-Regular.woff2';
// import PretendardSemiBold from './fonts/Pretendard-SemiBold.woff2';
import { createTheme } from './styles';
/*
    font refs = https://www.figma.com/file/jD6WSsI2j9rAmCf0qpVyvA/%F0%9F%92%9C-ENlighten-Design-System_2?node-id=11225%3A362624&mode=dev

    MUI의 font variant(https://mui.com/material-ui/customization/typography/)를 design-system의 variant로 치환
    h1
    h2
    h3
    h4
    h5
    h6
    subtitle1
    subtitle2
    body1
    body2
    button
    caption
    overline

    design-system
    h1
    h2
    h3
    h4
    h5
    h6
    b1
    b2
    b3
    b4
    b5
    b6

*/
export const defaultTheme = createTheme({
    typography: {
        // fontFamily: 'Regular, Arial',
        fontSize: 14,
        htmlFontSize: 14,
        fontWeightLight: 400,
        fontWeightRegular: 400,
        fontWeightMedium: 400,
        fontWeightBold: 400,
        h1: {
            fontSize: 32,
            color: coolGrey['1000'],
            lineHeight: 1.4,
        },
        h2: {
            fontSize: 28,
            color: coolGrey['1000'],
            lineHeight: 1.4,
        },
        h3: {
            fontSize: 24,
            color: coolGrey['1000'],
            lineHeight: 1.4,
        },
        h4: {
            fontSize: 22,
            color: coolGrey['1000'],
            lineHeight: 1.4,
        },
        h5: {
            fontSize: 20,
            color: coolGrey['1000'],
            lineHeight: 1.4,
        },
        h6: {
            fontSize: 18,
            color: coolGrey['1000'],
            lineHeight: 1.4,
        },
        b1: {
            fontSize: 16,
            color: coolGrey['1000'],
            lineHeight: 1.4,
        },
        b2: {
            fontSize: 15,
            color: coolGrey['1000'],
            lineHeight: 1.4,
        },
        b3: {
            fontSize: 14,
            color: coolGrey['1000'],
            lineHeight: 1.4,
        },
        b4: {
            fontSize: 13,
            color: coolGrey['1000'],
            lineHeight: 1.4,
        },
        b5: {
            fontSize: 12,
            color: coolGrey['1000'],
            lineHeight: 1.4,
        },
        b6: {
            fontSize: 11,
            color: coolGrey['1000'],
            lineHeight: 1.4,
        },
        subtitle1: undefined,
        subtitle2: undefined,
        body1: undefined,
        body2: undefined,
        button: undefined,
        caption: undefined,
        overline: undefined,
    },
    components: {
        // MuiCssBaseline: {
        // 	styleOverrides: `
        //     @font-face {
        //       font-family: 'Regular';
        //       font-style: normal;
        //       font-display: swap;
        //       font-weight: 400;
        //       src: url(${PretendardRegular}) format('woff2');
        //       unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        //     }
        // 		@font-face {
        //       font-family: 'Medium';
        //       font-style: normal;
        //       font-display: swap;
        //       font-weight: 500;
        //       src: url(${PretendardMedium}) format('woff2');
        //       unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        //     }
        // 		@font-face {
        //       font-family: 'SemiBold';
        //       font-style: normal;
        //       font-display: swap;
        //       font-weight: 600;
        //       src: url(${PretendardSemiBold}) format('woff2');
        //       unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        //     }
        // 		@font-face {
        //       font-family: 'Bold';
        //       font-style: normal;
        //       font-display: swap;
        //       font-weight: bold;
        //       src: url(${PretendardBold}) format('woff2');
        //       unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        //     }
        //   `,
        // },
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    b1: 'b1',
                    b2: 'b2',
                    b3: 'b3',
                    b4: 'b4',
                    b5: 'b5',
                    b6: 'b6',
                },
            },
        },
        MuiCard: {
            defaultProps: {
                variant: 'outlined',
            },
            styleOverrides: {
                root: {
                    borderRadius: 10,
                    borderColor: coolGrey['400'],
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: 11,
                    fontWeight: 500,
                    backgroundColor: coolGrey['800'],
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 10,
                    padding: 3,
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    minWidth: 225,
                },
            },
        },
    },
});
/* 각 테마는 https://mui.com/material-ui/customization/theming/ 맞춰서 작성 */
// https://mui.com/material-ui/customization/palette/
export const b2cTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: b2c['600'],
        },
        secondary: {
            main: b2b['600'],
        },
    },
});
export const b2bTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: b2b['600'],
        },
        secondary: {
            main: b2c['600'],
        },
    },
});
